const CapitalizeValueDisplay = (value) => {
  return value
    .split('_')
    .map((word) => { return word[0].toUpperCase() + word.substring(1) })
    .join(' ')
}

export default CapitalizeValueDisplay
